import { render, staticRenderFns } from "./team-introduction.vue?vue&type=template&id=38297661&scoped=true&"
import script from "./team-introduction.vue?vue&type=script&lang=js&"
export * from "./team-introduction.vue?vue&type=script&lang=js&"
import style0 from "./team-introduction.vue?vue&type=style&index=0&id=38297661&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38297661",
  null
  
)

export default component.exports